import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

export interface ISelectorItem {
  label: string;
  value: any;
  icon?: string; // Icon URL. Optional.
  sublabel?: string; // Extra text to show below the button. Optional.
  toggle?: {
    label: string;
    value: any;
    onChange: Function;
  };
  disabled?: boolean;
}

@Component({
  selector: "app-selector",
  templateUrl: "./selector.component.html",
  styleUrls: ["./selector.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectorComponent,
      multi: true,
    },
  ],
})
export class SelectorComponent implements OnInit, ControlValueAccessor {
  private _value: any;
  @Input() items: ISelectorItem[] = [];
  @Input() multilabel = true;
  @Input() disabled = false;
  @Input() get value(): any {
    return this._value;
  }
  set value(value: any) {
    this._value = value;
    this.onChangeCallback(this._value);
    this.changeValue.emit(this._value);
  }
  @Output() changeValue = new EventEmitter();
  open = false; // used for responsive element

  get selectedItem() {
    if (this.items) {
      return this.items.find((item) => item.value === this._value);
    } else {
      return null;
    }
  }

  constructor() {}

  ngOnInit() {
    if (!this._value && this.items.length) {
      this._value = this.items[0].value;
    }
  }

  toggleOpen() {
    this.open = !this.open;
  }

  isItemSelected(item: ISelectorItem) {
    return item.value === this._value;
  }

  selectItem(item: ISelectorItem) {
    if (!this.disabled && !item.disabled) {
      this.value = item.value;
    }
    this.open = false;
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  private onTouchedCallback = () => {
    /* Placeholder */
  };

  private onChangeCallback = (_: any) => {
    /* Placeholder */
  };
}
